var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecTypeCondition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C8 1.44772 8.44772 1 9 1H15C15.5523 1 16 1.44772 16 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44771 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H8ZM8 3H4V21H20V3H16C16 3.55228 15.5523 4 15 4H9C8.44772 4 8 3.55228 8 3ZM15 2H9V3H15V2ZM16.4341 8.74807L12.5781 15.4961C12.4 15.8077 12.0687 16 11.7098 16H10.7342C10.4374 16 10.156 15.8682 9.96597 15.6402L7.61589 12.8201L8.38411 12.1799L10.7342 15H11.7098L15.5659 8.25193L16.4341 8.74807Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecTypeCondition);
export default __webpack_public_path__ + "static/media/spec-type-condition.b1dfd89af01c07ba68173aecdb933288.svg";
export { ForwardRef as ReactComponent };